import React from 'react'
import { Card, CardContent, Grid } from '@mui/material'
import { Timestamp } from '@firebase/firestore'
import PageContainer from '../../../../components/container/PageContainer'
import Breadcrumb from '../../../../layouts/full-layout/breadcrumb/Breadcrumb'
import UnitForm from './UnitForm'
import UnitList from './UnitList'
import { UnitsProvider, useUnits } from '../../../../utils/context/units/UnitsContext'
import UsedInRecipes from '../UsedInRecipes'
import { getRecipeUnitsInUse } from '../../utils/admin'

function UnitsInUsePanel() {
  const { units, createUnits } = useUnits();
  return (
    <UsedInRecipes
      label="Units"
      fetchInUse={getRecipeUnitsInUse}
      curated={units.map((u) => u.unitName)}
      onAdd={async (value) => {
        await createUnits({
          unitName: value,
          dateCreated: Timestamp.fromDate(new Date()),
          unitId: '',
        });
      }}
    />
  );
}

export default function Units() {
  return (
    <UnitsProvider>
      <PageContainer title="Admin - Spenza" description="Admin page for Spenza.">
        <Breadcrumb title="Units" subtitle="Admin Tools" />
        <Grid container spacing={0}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Card>
              <CardContent>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <UnitForm />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <UnitList />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <UnitsInUsePanel />
                    </Grid>
                  </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </PageContainer>
    </UnitsProvider>
  )
}
